/**
 * @author Muhammad Hamza Khan
 * @datetime June, 28th 2022
 * @description: This is version info component modal which will be open on version
 *               info button and shows the current version info for API and Web.
 */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app--version-info',
  templateUrl: './version-info.component.html',
  styleUrls: ['./version-info.component.scss'],
})
export class VersionInfoDialogComponent {
  version: string;
  date: string;

  readonly LANG_CONST = LANG_CONST;

  constructor(
    public dialogRef: MatDialogRef<VersionInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.version = data?.version;
    this.date = data?.date;
  }
  /**
   * @description ##closeDialog method closes dialog
   */

  closeDialog() {
    this.dialogRef?.close();
  }
}
